import { SvgIcon } from '@mui/material';

function AppTrackingIcon() {
  return (
    <SvgIcon fontSize="inherit" viewBox="0 0 62 62" fill="none">
      <image
        id="image0"
        width="62"
        height="62"
        x="0"
        y="0"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAA+CAYAAABzwahEAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
              AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAA
              CXBIWXMAAAsTAAALEwEAmpwYAAALSklEQVRo3tWae3xV1ZXHf7+1z+M+Egw01jKgjrVaK+LYYkUL
              KKCSAAqj4TJCxSLVfCyOQkAqKJarQOoIA1IFoYwdHg5UQEpFQGgICCO2Vu2M46uKrSLTolJQ8rjJ
              zTl79Q9aWiTk3jzwhu+/Z+2d9b17n5O999rEiYG45LpO8J3TAHsuLLpCWXj4ka2Fyj6ofRei78A7
              eADbtwcnKI8mEmwreiXOAKQPqP0B9AD0dCg6Nvk3iDSAvQBfB3Q7LCoxoNurSCZt+xfvV9IToTsG
              0JFQ5B3ulb+H4kVAfwvoXgj2IZQqAIAGURinA6x2AfE1kF8D8HWoxgCkIXwOiiXw9m9ARcWn7U2c
              6Dfqcmo4G4qLAVgoXiDxlHWcZdi67E/N6m3gHT7q9l8qlrcpeS1U4wD3KvXfcMD8J15dXpN78f6J
              LrCRxygogmpIYIlVLsC2Za+D1FZn1Hd0gYgdpapTAO0MYLcGeht2/tfW3In3Hz2awEOAFpK6yjbo
              /dix/M22TOgIg0d2RJ17G8kyWFuowvkIOBPbl+z7/MQvS0SRlz+dqhMB7FHYsahYuuGECH+Wgbd0
              ZYNdBmg/EG9pg16H7UveOvHifUsL6dvltFpM4dqwQSeg8vH3Pxfpv0OuumUyiB+ASFvqAGx+/MVW
              9dfk0x6lMUb4JCHFMLIo7PDpiKyke1wTw7eu/2ZbituK/3iQjrkJIqFQNuHqWwa1pr/jj3giEWXN
              qWup9moQ0+3Gxx4AMny8+ia+BLi3wGoZgE4InO7Ytfy1tvwBMPC2XkJUQvGJDe0V2PLjFk374464
              1Jz6CIli0FlsN2QhfdWYSXQ7vELHn04/EhjPL4X3QavfxWPYtPB5K04RxETE9bZiyJj8lnTT6Iib
              oXfejFB/AnBDGP3j9Vi9On3cHq751/OoupzQiwG8Qw2nhRsW/rRN/rU1gQy+s5TUBQA3htFgJFYv
              qG5W+2NFyrqoShLGvO/a8PampE3J5BLxIpvFjV4kjj/Lp98v3Lho5YmWBgAb6/04xFkJ4bVS745u
              bvtjRtwMLXsG4CBauSpYP7vyuNIjfnAzrV0IIIW0TQQ/K//FiZY9hkRZ1ATyO7WassAV+PmcD7Jt
              evSID5vUB2IGwzE/bUravXHmTWL8x+lF3zOu3zMn0gCwem4K5FiKnGWMmdGcpn8TTySMo/IQjEkZ
              6IPHa+CN+fcS+JHF9CNvGCNF9U/c99ucSP+FcO2sdTSmEpQbcf34zs0Wd3huL4hcCpil6admv9qo
              9B0Lz6cfm0cvmhJXrqlbMuW9XEofhgpyFkXoSvSHzRZXYjQo1tAsaDSyb9IRE/kxPP80x3NurFtY
              1g6kDxOg/jnQqVCRIUgkv5S9eCJ5BmAGwJhd6dUPNLrgiPY8/064fi+4kbm180qfybXsUayem7LE
              Goh0NLT9shY3LvtQpAuBJxpbqBQkf1ZAx5tKL/KOl5f3UK49G8N6Zh3EWHElq6WsAICIXEljrGv8
              pxsLSpu82+FFO8KLTKtKDtmfa8lGWZ78iGJeAWUY+iadLMSVEH4D5Ou1T9z7x88GdJizqxNdf4L4
              kd1fyD9lXa79moSyApSI09W5JLP4tx/JB82XYcwbjQUE1jmbbqQTXP/hvRO+lcq1W1Mo+ApoQMdc
              lFHcc2pPJyWfIo2epNTedcmv4fjdq6tSi3ItlgnXN+/SSEDyzEyxDoycBxCq2HO8oOpx/9S2W8sT
              RCoVPeRG0p8QyCguCvd00EDEtM+PVnM450AtITVKOTWjOAUFEEFIVuU671aTTAYwJgSNlynUgQhA
              acuaSm4RA6hm3BY7NG4NVKFkNNc5twUEDYUZS1COpXwoBIzaL4S5zrq1lC6KQTSqQMbTGHHUvA0R
              UEzWW7r2Sp7vxiGSTzH/nynWoZE9oNaSODvXibcWy/AMQKIC7s4UK7WFX/6IxuyDZF7ttHdCuD0o
              BhaNr0KPEkeyX0DKGxDpjjt+5Oc6+dYgIgMhAnH4P5nFAYDuNlBivlfQN9fJt5iyVVFrpD/FvJya
              +52M7/jhbalxKiFOCJrSXOffUuJOug8pHSxkZTbxAgA1dXlvikil0FweG7/8pPy6h/SGk2Khsj5r
              cTwyqN5SnoBIoUb8klxLNJf8KWvPhXAEoC/Vz7nh7ezFAdRFC1fAmE9Acw/Kdp1Uq7hA9HtIVcXq
              frOlK/qUXNgscST7BYSZBJHO8dj+cbmWyRZ/6ppzQFOqQfpthA0FNJEN6D2qZ/biAPLT0ZUUs9sS
              U3H3qlNyLZWRxCpj6D1KimM6fnGi0gyE40UYMc/iypuaHPmjxD+cXVQDOhMoEotFYs8guSrj9i6X
              RLvlJ0AZAJEVtc6rG1G5dIcxzggaz6Mb2YiiW7tlJQ4AtQ8MWg+R+aD0ijL/9lzLHY94cstFBJZC
              zLuSlu//9VJgsHlxhRXvWjquL67/3+6gcY1O+0YvBsQRnUIxu0GZGU8+W5xryc8SnbaxK4gnVSRt
              yVurfzjo46MCNj1aKcYdQeMGocs1GDLumGnfqPjHyX7VNN71QqlS46yNzNh8ea5l/0rn5NMxcby1
              EJ4r4PS6acXbGosLfv5wBcUZReN1Mo6/ASUTz/v7502eu+SXb78shN0K1ZQNzLC6aX23IYdEZ2zt
              IuQKQC9XxX21U6/MWBp2ElP7g1gPRVrE9kk/Wf4akOHWU9U9fV8Qa4opTmBcVsTKt30XiVUmJ9Ll
              lb2McbdC5DKFTK0NdpZn0y5YPaNS6fwLXNe3xl+MEclCIMuTtvisHRfCytNQe6aSCxy35r5DE4oP
              fF7SeQ/uuEHJx6A4hdBx1Xf3ebS5103c78ycDcVEAOMblt07L+sjxk4/+mWHhrrgSVUWK7jP2vDO
              1OTea07kfRd/zravOIG3iIr+JN5X1Zur7+7dstctkfTc/Lw9UO5vOLPqwuadraoyb/YLtwOcAuAf
              lNgK6Kya6i2/aLM75qqMz33hAlr5LlRHAcxT1RWq4b21d/f+Q2u6dkvnzSH0Dga4oEWHyh0ffumM
              IAiSSpOA2jgoOxT2J7TBs9WTen3UoqySSYnHi/pDnBsAOxINDVEEdW8bP3/CoUk92+TerDt24U2i
              dqkCozKWUxvj4PiL9wAY02H+y+W2gd9X5UiCV0CMzZvz8m8gXAcb7Awd+26eyfvk47Hdao68Eqrs
              fP/L0UMFfr4G6a6Ow26h1cGgDiYQB1Cnav433PdmVw2DrgFY3xbSAGAc9wNVBVS/0iZlhA5zdnUC
              I0WWGEqgBIADAAoEhBwCtBbUeoCAwgCIAYgDGj/SCfFLq1hDhpurD254wzt41gUUPkcggLUldfNG
              72htnn7ZkgFUbgYxpc3rJ6fOfy0vFdoesNpNRL+qii4q6EilAegDWg/VAxB8DOD3gLwVOPbXqe9d
              dMxxUfSulT2VWANFJ8BcWzd7eGULUvqb+MQVY0nMJzGs3ReO4vesudBablJogQJD6x8cVtHSvqKT
              n1oLaLGk0me1e3EAiN+3rrsqdwJosIqSuplDmz3to/eu7wLatwjuqp0xpEia20EuqJn+z/+ndIpg
              3Bo67ia/uRsnVYrrLKHjRSDOw0Cmi/rtiNT0wb+i5w0RxztojHkqNr3immzanXbX5nisfOsjMO5V
              MM7i2jertwAnYXE4r3zH+SrYpaqekHOr6/bdj+TwRm9Y583a/EUNossBHUBil4v0oIOTr/70pBQH
              gFMeev7sUGQJVHsruJfkRrX2ear9wNKJiob/CCNXQDEMhAV0UfWv9o7D6uFHCsInpTgA5M9+qdCK
              /TYptwL4KqCfWYwxpYqdEtpHq858byOGDz+qCn7Sih8hmZT8guvOAe2lau1ZJOtCq69TvBdrxnf/
              8HjN/gy8ZRWt+tuhlAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMy0wNy0wNVQxMzo1OTo1MyswMjow
              MHsFS60AAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjMtMDctMDVUMTM6NTk6NTMrMDI6MDAKWPMRAAAA
              AElFTkSuQmCC"
      />
    </SvgIcon>
  );
}

export default AppTrackingIcon;
